import moment from 'moment'

import soil from './modules/soil'
import crop from './modules/crop'
import fertilizer from './modules/fertilizer'
import simulation from './modules/simulation'
// eslint-disable-next-line camelcase
import chk_irrigation from './modules/chk_irrigation'
import irrigation from './modules/irrigation'
import editor from './modules/editor'
import region from './modules/region'
import tooltip from './modules/tooltip'
import { Tab, TabList } from './constants'

const getters = {
  inSeasonBuffer: (state, getters) => {
    const { seedingDate, harvestDate } = state.crop
    return state.simulation.buffer.filter(it => {
      const date = moment(it.Date, 'DD.MM.YYYY').toDate()
      return seedingDate <= date && date <= harvestDate
    })
  }
}

const mutations = {
  tabChange (state, tab) {
    if (!TabList.includes(tab)) {
      throw new Error(`Invalid tab ${tab}`)
    }
    state.tab = tab
  },
  error (state, error) {
    console.error(error)
    state.error = error
  },
  toggleAdvancedCropSettings (state) {
    state.isAdvancedCropSelected = !state.isAdvancedCropSelected
  },
  toggleAdvancedLocationSettings (state) {
    state.isAdvancedLocationSelected = !state.isAdvancedLocationSelected
  }
}

const actions = {
  setCropType ({ commit, state }, value) {
    commit('crop/setType', value)
    commit('simulation/setDates', {
      startDate: moment(state.crop.seedingDate).toDate(),
      endDate: moment(state.crop.harvestDate).toDate()
    })
    commit('fertilizer/updateOrganicApplication', {
      index: 0,
      date: moment(state.crop.seedingDate).add(1, 'd').toDate()
    })
  },
  setRegion ({ commit, dispatch, state }, region) {
    commit('region/setType', region)
    dispatch('crop/loadTypes', state.region.type.id)
    dispatch('soil/loadTypes', state.region.type.id)
  },
  keepOrganicApplicationsInRange ({ commit, state }) {
    for (let index = 0; index < state.fertilizer.organicApplications.length; index++) {
      const organicApplication = state.fertilizer.organicApplications[index]
      if (organicApplication.date <= state.crop.seedingDate) {
        commit('fertilizer/updateOrganicApplication', {
          index,
          date: moment(state.crop.seedingDate).add(1, 'd').toDate()
        })
      } else if (organicApplication.date >= state.crop.harvestDate) {
        commit('fertilizer/updateOrganicApplication', {
          index,
          date: moment(state.crop.harvestDate).subtract(1, 'd').toDate()
        })
      }
    }
  },
  setSeedingDate ({ state, commit, dispatch }, seedingDate) {
    commit('crop/setSeedingDate', seedingDate)
    if (!state.isAdvancedCropSelected) {
      commit('simulation/setDates', {
        startDate: state.crop.seedingDate,
        endDate: state.crop.harvestDate
      })
    }
    dispatch('keepOrganicApplicationsInRange')
  },
  setHarvestDate ({ state, commit, dispatch }, harvestDate) {
    commit('crop/setHarvestDate', harvestDate)
    if (!state.isAdvancedCropSelected) {
      commit('simulation/setDates', {
        startDate: state.crop.seedingDate,
        endDate: state.crop.harvestDate
      })
    }
    dispatch('keepOrganicApplicationsInRange')
  },
  setSimulationStartDate ({ commit }, startDate) {
    commit('simulation/setStartDate', startDate)
  },
  setSimulationEndDate ({ commit }, endDate) {
    commit('simulation/setEndDate', endDate)
  },
  loadTypes ({ dispatch }) {
    dispatch('region/loadTypes')
    dispatch('soil/loadTypes')
    dispatch('fertilizer/loadTypes')
    dispatch('fertilizer/loadOrganicTypes')
    dispatch('irrigation/loadTypes')
  }
}

export default function createMainStoreConfig () {
  const state = {
    tab: Tab.CROP_SOIL,
    error: null,
    isAdvancedCropSelected: false,
    isAdvancedLocationSelected: false
  }

  return {
    state,
    getters,
    mutations,
    actions,
    modules: {
      soil,
      crop,
      fertilizer,
      chk_irrigation,
      irrigation,
      simulation,
      editor,
      region,
      tooltip
    },
    plugins: []
  }
}
